// extracted by mini-css-extract-plugin
export default {"button":"Print_button__AlgvL","btnIcon":"Print_btnIcon__hCiWS"};